import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {useRouter} from '../../../../../@casino/useRouter';
import BreadCrumbs from '../../components/breadCrumbs';
import {setGetLastOperation} from '../../store/thunk/setGetLastOperation';
import TableCasino from '../../../../../@casino/ui/table';
import {columns, getRows} from './helpers';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    p20: {
        padding: 20, 
    }
}))

const ReportEventGamer = () => {
    const router = useRouter();
    const id = router.match.params.id;
    const dispatch = useDispatch();
    const classes = useStyles();

    React.useEffect(() => {
        if (id) {
            dispatch(setGetLastOperation({
                id,
                page: 1,
                rowsPerPage: 500
            }))
        }
    }, [id])

    const operation = useSelector(state => state.users.last_operation);  
    const rows = React.useMemo(() => getRows(operation.data), [operation]);
    
    return (
        <div>
            <BreadCrumbs label={id} description='Отчет о событиях'/>
            <div className={classes.p20}>
                <TableCasino
                    pagination  
                    allPage={operation.allPage}
                    width={1280}
                    perPage={500}
                    columns={columns}
                    rows={rows}
                    changePage={(v) => dispatch(setGetLastOperation({
                        page: +v.page+1,
                        rowsPerPage: v.rowsPerPage,
                        id
                    }))}
                    changeRowsPerPage={(v) => dispatch(setGetLastOperation({
                        page: +v.page + 1,
                        rowsPerPage: v.rowsPerPage,
                        id
                    }))}
                />
            </div>
           
        </div>
    )
}

export default ReportEventGamer;